import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { HttpApiError } from '../models/http-api-error';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage = 'An error occurred';

        if (error.error instanceof ErrorEvent) {
          // Client-side error
          errorMessage = `Client Error: ${error.error.message}`;
        } else {
          // Server-side error
          switch (error.status) {
            case 401:
              // Unauthorized - logout and redirect to login
              this.authService.logout();
              errorMessage = 'Unauthorized. Please login again.';
              break;

            case 403:
              // Forbidden
              errorMessage = 'You do not have permission to perform this action.';
              this.router.navigate(['/forbidden']);
              break;

            case 404:
              // Not found
              errorMessage = 'The requested resource was not found.';
              break;

            case 422:
              // Validation error
              errorMessage = error.error?.message || 'Validation error occurred.';
              break;

            case 500:
              // Internal server error
              errorMessage = 'Internal server error. Please try again later.';
              break;

            case 503:
              // Service unavailable
              errorMessage = 'Service temporarily unavailable. Please try again later.';
              break;

            default:
              errorMessage = error.error?.message || `Server Error (${error.status}): ${error.statusText}`;
          }
        }

        // Log error to console
        console.error('HTTP Error:', {
          url: request.url,
          method: request.method,
          status: error.status,
          message: errorMessage,
          error: error
        });

        // Show error notification (would integrate with a toast service)
        this.showErrorNotification(errorMessage);

        return throwError(() => new HttpApiError(errorMessage, error.status, error.error?.code, error.error));
      })
    );
  }

  private showErrorNotification(message: string): void {
    // TODO: Integrate with PrimeNG Toast service
    console.error('Error Notification:', message);
  }
}
